import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';
import classnames from 'classnames';

import theme from './CreateNewAppointmentPlaceholder.scss';

const propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

const CreateNewAppointmentPlaceholder = ({ isMobile }) => (
  <div className={ classnames(theme.root, { [theme.mobile]: isMobile }) }>
    <img
      className={ theme.arrow }
      src="/assets/img/arrow-ltr.svg"
      alt="arrow"
    />
    <FormattedHTMLMessage
      id="Patient.Appointment.Create.ServiceSelectionWatermark"
      defaultMessage="** Start by selecting a service"
    />
  </div>
);

CreateNewAppointmentPlaceholder.propTypes = propTypes;

export default CreateNewAppointmentPlaceholder;
